import {Component, HostBinding} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {AuthorizationService} from '../../authorization/authorization.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-user-menu-info',
  templateUrl: './user-menu-info.component.html',
})
export class UserMenuInfoComponent {
  @HostBinding('class.header-menu-item') userMenu = true;
  userMenuIsOpen = false;
  documentation = environment.documentation;

  constructor(
    private oauthService: OAuthService,
    public authorizationService: AuthorizationService,
  ) {
  }

  getLogin() {
    return (this.authorizationService && this.authorizationService.getIdentity()) ?
      this.authorizationService.getIdentity().login : '';
  }
}
